<template>
  <div
    v-if="item.goodsCode"
    class="goods-item-pc"
    @click="$router.push(`/prodetail/${item.goodsCode}`)"
  >
    <div class="goods-image-wrapper">
      <!-- 商品图片 -->
      <img
        :src="item.goodsImage || defaultImage"
        :alt="item.goodsName || $t('pcHome.productImage')"
        @error="handleImageError"
        class="goods-image"
      />
      <!-- 精选 -->
      <div
        v-if="item.goodsType === 1 || item.type == 1"
        class="tag tag-selected"
      >
        {{ $t("pcHome.shortcut.featured") }}
      </div>
      <!-- 求 -->
      <div v-if="item.goodsType === 2 || item.type == 2" class="tag tag-buy">
        {{ $t("marketComponents.buy") }}
      </div>
    </div>
    <div class="goods-content">
      <h3 class="goods-title">
        {{ showPartNumber ? (item.goodsNum || "--") : (item.goodsName || item.title) }}
      </h3>
      <div
        class="goods-tags"
        v-if="item.handleTags && item.handleTags.length > 0"
      >
        <span v-for="(items, indexs) in item.handleTags" :key="indexs">
          {{ items }}
        </span>
      </div>
      <div class="price-row">
        <div
          class="goods-price"
          v-if="item.priceUnit == 0 || item.priceUnit == 10"
        >
          <span class="price-value">{{ $formatPrice(item.salePrice) }}</span>
          <span class="price-symbol">{{ priceSymbol }}</span>
        </div>
        <!-- <div class="goods-meta">
          <span class="goods-quantity"
            >余{{ item.quantity ?? 0 }}{{ item.goodsUnit ?? "个" }}</span
          >
        </div> -->
        <div class="goods-contact" v-if="item.shopContacts">
          <img
            class="contact-avatar"
            :src="item.shopContactsImage || require('@/img/prodetail/x.png')"
          />
          <span>{{ item.shopContacts }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "GoodsItem",
  props: {
    showPartNumber: { type: Boolean, default: false },
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      defaultImage: require("@/assets/default-goods.png"),
    };
  },
  computed: {
    ...mapState({
      priceUnitCNY: (state) => state.price.priceUnitCNY,
      priceUnitUSD: (state) => state.price.priceUnitUSD,
    }),
    // 获取价格单位符号
    priceSymbol() {
      if (!this.item.priceUnit && this.item.priceUnit !== 0) return "";
      const usdUnit = this.priceUnitUSD;
      const cnyUnit = this.priceUnitCNY;

      // 如果没有配置，使用默认值
      if (!usdUnit || !cnyUnit) {
        return this.item.priceUnit === 10 ? "USD" : "CNY";
      }

      const usdValue = Number(usdUnit.value != null ? usdUnit.value : 10);
      // 根据priceUnit值返回对应的符号（优先使用remark，如果没有则使用name的第一个字符）
      if (this.item.priceUnit === usdValue) {
        return (
          `${usdUnit.name}${usdUnit.remark}` || usdUnit.name?.charAt(0) || "USD"
        );
      } else {
        return (
          `${cnyUnit.name}${cnyUnit.remark}` || cnyUnit.name?.charAt(0) || "CNY"
        );
      }
    },
  },
  methods: {
    handleImageError(e) {
      // 避免无限循环（如果默认图也加载失败）
      if (e.target.src !== this.defaultImage) {
        e.target.src = this.defaultImage;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.goods-item-pc {
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 16px;
  padding: 12px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);

    .goods-image {
      transform: scale(1.03);
    }
  }

  .goods-image-wrapper {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 100%;
    border-radius: 12px;
    overflow: hidden;
    margin-bottom: 10px;

    .goods-image {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .tag {
      position: absolute;
      top: 10px;
      left: 10px;
      padding: 4px 12px;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 500;
      color: #ffffff;

      &.tag-selected {
        background: linear-gradient(135deg, #4689f2 0%, #357ae8 100%);
      }

      &.tag-buy {
        background: linear-gradient(135deg, #f95348 0%, #e84338 100%);
      }
    }
  }

  .goods-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;

    .goods-title {
      display: block;
      min-width: 0;
      overflow: hidden;
      margin: 0;
      font-size: 13px;
      font-weight: 500;
      color: #1a1a1a;
      line-height: 1.5;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .price-row {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
    }

    .goods-tags {
      display: flex;
      flex-wrap: wrap;
      gap: 4px;

      span {
        display: inline-block;
        padding: 2px 6px;
        border-radius: 5px;
        background: #f2f5f8;
        color: #6b7280;
        font-size: 12px;
        line-height: 18px;
      }
    }

    .goods-price {
      display: flex;
      align-items: baseline;
      gap: 2px;

      .price-value {
        font-size: 18px;
        font-weight: 700;
        color: #4286f5;
        line-height: 1.2;
      }

      .price-symbol {
        font-size: 12px;
        font-weight: 600;
        color: #4286f5;
      }
    }

    .goods-meta {
      .goods-quantity {
        font-size: 12px;
        color: #999999;
      }
    }

    .goods-contact {
      display: flex;
      align-items: center;
      gap: 4px;
      color: #666666;
      font-size: 12px;

      .contact-avatar {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        object-fit: cover;
      }
    }
  }
}
</style>
